export const lifewayCompany = {
  name: 'LIFEWAY s.r.o.',
  address: 'Mýtna 42, PSČ: 811 05 Bratislava Staré Mesto, Slovensko',
  ic: '55 803 482',
  dic: '2122090432',
  email: 'posta@belifeway.com',
  website: 'belifeway.com',
};

export const bonatoCompany = {
  name: 'BONATO s.r.o.',
  residenceAddress: 'Mýtna 42, 811 05 Bratislava Staré Mesto',
  contactAddress: 'P.O. BOX B17, 010 01 Žilina',
  contactAddressLine1: 'P.O. BOX B17',
  contactAddressLine2: '010 01 Žilina',
  ic: '51 498 928',
  dic: '2120724551',
  description: 'obchodná spoločnosti zapísaná v OR vedenom na OS v Žiline odd: S.r.o. vl.č. 69784/L',
  ceo: 'Bučko Zdeněk',
  bank: '365.bank, a. s. (Poštová banka)',
  iban: 'SK49 8330 0000 0023 0266 1356',
};
